<div class="content_top_margin bot_spa_aft_sect_heading">
    <form [formGroup]=" addressForm" action="" method="get">
        <fieldset>
            <legend class="sectionHeading_one legend_display bot_spa_aft_sect_heading" id="estVal">
                {{'estimate_value_of_home.estimateText'|translate}}
            </legend>
            <div class="row no-gutters bot_spa_aft_sect_heading">
                <div class="col-12">
                    <label class="d-flex align-items-center field_lable_bot_margin_unset">
                        <div [ngClass]="selectedRadio==='address'?'cst-rd-check':'cst-rd'">
                            <input type="radio" id="address" formControlName="address" value="address"
                                name="estAddress">
                            <div class="border-on-focus"></div>
                        </div>
                        <span class="ml-2 appLabel">{{addressline1}} {{city}} {{province}}
                            {{postal_code}}</span>
                    </label>
                </div>
            </div>
            <div class="row no-gutters">
                <div class="col-12">
                    <label class="d-flex align-items-center field_lable_bot_margin_unset">
                        <div [ngClass]="selectedRadio==='other'?'cst-rd-check':'cst-rd'">
                            <input type="radio" id="other" formControlName="address" value="other" name="estAddress">
                            <div class="border-on-focus"></div>
                        </div>
                        <span class="ml-2 appLabel">Other</span>
                    </label>
                </div>
            </div>
        </fieldset>
        <ng-container *ngIf=" selectedRadio==='other'">
            <div class="row no-gutters top_spa_aft_sect_heading bot_spa_aft_sect_heading">
                <div class="col-12 col-md-8">
                    <small
                        class="form-text col-xs-12 col-sm-12 d-flex align-items-center field_heading_minHeight_label  p-0 m-0">
                        <label for="streetName" class="field_lable_bot_margin_unset">{{ 'address.street' | translate }}
                        </label>
                    </small>
                    <input id="streetName" type="text" (change)="tempAddressSession()" required name="streetName"
                        formControlName="streetName" class="wdd-fl border-cls" autocomplete="street-address"
                        aria-describedby="teststreetname" placeholder="Enter a location"
                        [ngClass]="(f.streetName.touched || submitted) && (f.streetName.errors?.required || f.streetName.errors?.invalidStreet) ? 'invalidBorder' : 'nonSelectBorder'"
                        maxlength="35">
                    <div class="row no-gutters">
                        <div class="col-12">
                            <small id="teststreetname"
                                *ngIf="f.streetName.errors?.invalidStreet && !f.streetName.errors?.required"
                                class="d-flex align-items-start mt-1"> <img src="./assets/images/menu_icons/Alert.svg"
                                    alt="">
                                <span class="ml-2">
                                    {{'address.streetValid' | translate}}
                                </span>
                            </small>
                        </div>
                    </div>

                    <div class="row no-gutters"
                        *ngIf="f.streetName.invalid && (f.streetName.dirty || f.streetName.touched || submitted)">
                        <small id="teststreetname" *ngIf="f.streetName.errors?.required && !f.streetName.valid "
                            class="d-flex align-items-start mt-1"> <img src="./assets/images/menu_icons/Alert.svg"
                                alt=""> <span class="ml-2">
                                {{'address.streetValid' | translate}}
                            </span>
                        </small>
                    </div>

                </div>
                <div class="col-12 col-md space_between_field">
                    <small
                        class="form-text col-xs-12 col-sm-12 d-flex align-items-center field_heading_minHeight_label p-0 m-0">
                        <label for="address2" class="field_lable_bot_margin_unset">{{ 'address.unit' | translate }}
                        </label>
                    </small>
                    <input type="text" class="wdd-fl border-cls" [readonly]="loader " (change)="tempAddressSession()"
                        tabindex="0" aria-describedby="apartmentdesc" id="address2" name="address2"
                        formControlName="apartment" autocomplete="address-level3"
                        [ngClass]="f.apartment.errors?.invalidApartment ? 'invalidBorder' : 'nonSelectBorder'"
                        maxlength="4">
                    <div class="row no-gutters">
                        <div class="col-12">
                            <small id="apartmentdesc" *ngIf="f.apartment.errors?.invalidApartment "
                                class="d-flex align-items-center mt-1">
                                <img src="./assets/images/menu_icons/Alert.svg" alt="">
                                <span class="ml-2">
                                    {{'address.apartmentValid' | translate}}
                                </span>
                            </small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row no-gutters">
                <div class="col-12 col-md">
                    <small
                        class="form-text col-xs-12 col-sm-12 d-flex align-items-center field_heading_minHeight_label p-0 m-0">
                        <label for="locality" class="field_lable_bot_margin_unset">{{ 'address.city' | translate }}
                        </label>
                    </small>
                    <input type="text" class="wdd-fl border-cls" [readonly]="loader " (change)="tempAddressSession()"
                        tabindex="0" required id="locality" name="locality" aria-describedby="testcity"
                        aria-required="true" formControlName="city" autocomplete="address-level2"
                        [ngClass]="(f.city.touched || submitted) && (f.city.errors?.required || f.city.errors?.invalidCity) ? 'invalidBorder' : 'nonSelectBorder'"
                        maxlength="24">
                    <div class="row no-gutters">
                        <div class="col-12">
                            <small id="testcity" *ngIf="f.city.errors?.invalidCity && !f.city.errors?.required"
                                class="d-flex align-items-start mt-1"> <img src="./assets/images/menu_icons/Alert.svg"
                                    alt="">
                                <span class="ml-2">
                                    {{'address.cityValid' | translate}}
                                </span>
                            </small>
                        </div>
                    </div>
                    <div class="row no-gutters" *ngIf="f.city.invalid && (f.city.dirty || f.city.touched || submitted)">
                        <small id="testcity" *ngIf="f.city.errors?.required && !f.city.valid "
                            class="d-flex align-items-start mt-1"> <img src="./assets/images/menu_icons/Alert.svg"
                                alt=""> <span class="ml-2">
                                {{'address.cityValid' | translate}}
                            </span>
                        </small>
                    </div>

                </div>
                <div class="col-12 col-md-5 space_between_field">
                    <small
                        class="form-text col-xs-12 col-sm-12 d-flex align-items-center field_heading_minHeight_label p-0 m-0">
                        <label for="state" class="field_lable_bot_margin_unset">{{ 'address.province' | translate }}
                        </label>
                    </small>
                    <div [ngClass]="isIos ? 'select-wrapper col-12 p-0 m-0':'NotAvailabeDkmk'">
                        <select *ngIf="currentLang == 'en'" class="wdd-fl border-cls" tabindex="0" required id="state"
                            name="state" aria-describedby="teststate" (change)="tempAddressSession()"
                            aria-required="true" formControlName="province"
                            [ngClass]="(f.province.touched || submitted) && (f.province.errors?.required) ? 'invalidBorder' : 'nonSelectBorder'">
                            <option value=""></option>
                            <option *ngFor="let province of provinceOptions; let i = index" [value]="province.code">
                                {{province.nameEn}}</option>

                        </select>

                        <select *ngIf="currentLang == 'fr'" class="wdd-fl border-cls" tabindex="0" required id="state"
                            name="state" aria-required="true" formControlName="province" (change)="tempAddressSession()"
                            [ngClass]="(f.province.touched || submitted) && (f.province.errors?.required) ? 'invalidBorder' : 'nonSelectBorder'">
                            <option value=""></option>
                            <option *ngFor="let province of provinceOptions; let i = index" [value]="province.code">
                                {{province.nameFr}}</option>

                        </select>
                    </div>
                    <div class="row no-gutters"
                        *ngIf="f.province.invalid && (f.province.dirty || f.province.touched || submitted)">
                        <small id="teststate" *ngIf="f.province.errors?.required && !f.province.valid "
                            class="d-flex align-items-start mt-1"> <img src="./assets/images/menu_icons/Alert.svg"
                                alt=""> <span class="ml-2">
                                {{'address.perrormsg' | translate}}
                            </span>
                        </small>
                    </div>

                </div>
                <div class="col-12 col-md space_between_field">
                    <small
                        class="form-text col-xs-12 col-sm-12 d-flex align-items-center field_heading_minHeight_label p-0 m-0">
                        <label for="postcode" class="field_lable_bot_margin_unset">{{ 'address.code' | translate }}
                        </label>
                    </small>
                    <input type="text" class="wdd-fl border-cls" [readonly]="loader" tabindex="0" required
                        (change)="tempAddressSession()" id="postcode" name="postcode" maxlength="7"
                        aria-describedby="testpostcode" aria-required="true" formControlName="postalCode"
                        autocomplete="postal-code"
                        [ngClass]="(f.postalCode.touched || submitted) && (f.postalCode.errors?.required || f.postalCode.errors?.pattern) ? 'invalidBorder' : 'nonSelectBorder'">

                    <div class="row no-gutters">
                        <div class="col-12">
                            <small id="testpostcode"
                                *ngIf="f.postalCode.errors?.pattern && !f.postalCode.errors?.required"
                                class="d-flex align-items-start mt-1"> <img src="./assets/images/menu_icons/Alert.svg"
                                    alt="">
                                <span class="ml-2">
                                    {{'address.postalValid' | translate}}
                                </span>
                            </small>
                        </div>
                    </div>

                    <div class="row no-gutters"
                        *ngIf="f.postalCode.invalid  && (f?.postalCode.dirty || f?.postalCode.touched || submitted)">
                        <div class="col-12">
                            <small id="testpostcode" *ngIf="f.postalCode.errors?.required && !f.postalCode.valid"
                                class="d-flex align-items-start mt-1"> <img src="./assets/images/menu_icons/Alert.svg"
                                    alt=""> <span class="ml-2">
                                    {{'address.postalValid' | translate}}
                                </span>
                            </small>
                        </div>
                    </div>

                </div>
            </div>
        </ng-container>
    </form>
</div>
<div class="row no-gutters  bot_spa_aft_sect_heading">
    <div class="col-12">
        <span class="sectionHeading_one">
            {{'estimate_value_of_home.howMuchValue'|translate}}
        </span>
        <span>
            <button class="infoButton" tabindex="0" type="button" id="btnttltip" (click)="$event.stopPropagation();"
                #ert="ngbPopover" [autoClose]="true" [ngbPopover]="popContent" placement="bottom"
                [attr.aria-label]="'estimate_value_of_home.homeTooltipSr'|translate">
                <img aria-hidden="true" src="./assets/icons/helpIcon.svg" class="mb-1" alt="helpIcon-icon"
                    role="dialog">
                <span class="show-for-sr" id="incomeTextAcc">{{'"estimate_value_of_home".iconToolTip' | translate
                    }}</span>
            </button>
        </span>
    </div>
</div>
<form [formGroup]="estimate">
    <div class="row no-gutters">
        <div class="col-md-5 col-lg-4 col-12" *ngIf="currentLang == 'en'">
            <input type="text" id="estimateValue" appMycurrency formControlName="estimateValue"
                class="wdd-fl border-cls"
                [ngClass]="displayValidation ? 'validationBorder':isSelected?'selectBorder':'nonSelectBorder' "
                aria-describedby="propertyValue" autocomplete="off" (focus)="isSelected=true" (blur)="isSelected=false"
                aria-labelledby="estimate" aria-required="true" maxlength="10">
        </div>
        <div class="col-md-5 col-lg-4 col-12" *ngIf="currentLang == 'fr'">
            <div class="input-wrapper">
                <input type="text" id="estimateValue" appMycurrencyFr formControlName="estimateValue"
                    class="wdd-fl border-cls"
                    [ngClass]="displayValidation ? 'validationBorder':isSelected?'selectBorder':'nonSelectBorder' "
                    aria-describedby="propertyValue" autocomplete="off" (focus)="isSelected=true"
                    (blur)="isSelected=false" aria-required="true" aria-labelledby="estimate" maxlength="8">
            </div>
            <div class="iconAlignT">
                <span>$</span>
            </div>
        </div>
        <div class="row no-gutters top_spa_aft_sect_heading">
            <div class="col-12">
                <small *ngIf="displayValidation &&submittedamount" id="propertyValue"
                    class="d-flex align-items-start mt-1 errorMsg"> <img aria-hidden="true"
                        src="./assets/images/menu_icons/Alert.svg" alt=""> <span class="ml-2">
                        {{'estimate_value_of_home.validation' | translate}}
                    </span>
                </small>
            </div>
        </div>
    </div>
</form>
<div class="row no-gutters top_height_actionButton content_top_mobile_margin">
    <div class="col-12 d-flex d-md-block flex-column-reverse">
        <cancel-button></cancel-button>
        <button type="button" class="common_btn saveNextBtn_features space_between_button"
            (click)="onContinue()">{{'buttonallpages.continuelable' | translate }}</button>
    </div>
</div>

<ng-template #popContent class="popContent">
    <div role="dialog" cdkTrapFocus [cdkTrapFocusAutoCapture]="true" class="tooltip-content">
        <button type="button" class="close closettp" (click)="closeTolltip()" aria-label="Close" data-toggle="tooltip"
            data-placement="top">
            <span class="popUpClose" aria-hidden="true">&times;</span>
            <span class="show-for-sr">{{'persInfo.close' | translate}}</span>
        </button>
        <div class="modal-body p-3">{{ 'estimate_value_of_home.iconToolTip' | translate }}
        </div>
    </div>
</ng-template>